export const transformFilterData = (array) => array
    ? array.map(({ id, value }) => {
        let newId = id
        if (newId.startsWith('filter')) {
            newId = newId.replace('filter', '')
            newId = newId[0].toLowerCase() + newId.slice(1)
        }
        return { id: newId, value }
    })
    : []